import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ark-lib-single-founder-info-modal',
  templateUrl: './single-founder-info-modal.component.html',
  styleUrls: ['./single-founder-info-modal.component.css'],
})
export class SingleFounderInfoModalComponent  implements OnInit {

  constructor() { }

  ngOnInit() {}

}
